import * as styledElements from "../ElementsTableStyles";
import Icon from "../../../../common/Icon";
import React, { Dispatch, SetStateAction } from "react";
import {
  BillableElement,
  Board,
  SelectedElement,
} from "../../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../../../utils/hooks/commonly-stored/uploaded-board/board";
import { trackOpenSelectPartForm } from "../../../../../utils/observability/boardTracking";

export default function SelectPartButton({
  element,
  setSelectedElement,
  disableEditing,
}: {
  element: BillableElement;
  setSelectedElement: Dispatch<SetStateAction<SelectedElement | null>>;
  disableEditing: boolean;
}) {
  const board = useBoardFromContext().board as Board;
  const openSelectPartForm = () => {
    if (!disableEditing) {
      trackOpenSelectPartForm(board, element);
      setSelectedElement({
        elementId: element.id,
      });
    }
  };

  return (
    <styledElements.EditButton
      onClick={disableEditing ? undefined : openSelectPartForm}
      disabled={disableEditing}
    >
      <Icon src="/icons/pencil.svg" alt="edit" />
    </styledElements.EditButton>
  );
}
